import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResourceService } from './resource-service';
import { Campaign } from '../models/campaign';

interface UpdateBudgetPayload {
  campaignId: string;
  newBudget: number;
}
@Injectable({
  providedIn: 'root',
})
export class CampaignsService extends ResourceService<Campaign> {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, '/api/amz-advertising/campaigns');
  }

  updateBudgets(payload: UpdateBudgetPayload[], {currencyCode, marketplaceId}: {currencyCode: string, marketplaceId: string}) {
    let params = new HttpParams();
    params = params.set('currencyCode', currencyCode);
    params = params.set('marketplaceId', marketplaceId);

    return this.httpClient.post(`${this.apiUrl}/update-budgets`, payload, { params })
  }
}
